import React from 'react';
import { Card, CardContent, Box, Typography, Stack, Chip, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  ChevronRight, 
  DescriptionOutlined, 
  AddCircleOutline 
} from '@mui/icons-material';

export const AssessmentCard = ({ type, onConfigure }) => {
  const { is_configured, name, last_updated, id } = type;
  const navigate = useNavigate();
  const { clientID } = useParams();

  const handleCardClick = () => {
    if (is_configured) {
      navigate(`/${clientID}/assessments/initial-assessment/${id}/view`);
    }
  };

  return (
    <Card 
      variant="outlined" 
      onClick={handleCardClick}
      sx={{ 
        borderRadius: 3, 
        cursor: is_configured ? 'pointer' : 'default',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', 
        border: is_configured ? '1px solid #c8e6c9' : '1px solid #eaecf0',
        bgcolor: is_configured ? '#f9fff9' : '#fff',
        position: 'relative',
        '&:hover': { 
          boxShadow: is_configured ? '0px 10px 20px rgba(16, 24, 40, 0.08)' : 'none', 
          borderColor: is_configured ? '#81c784' : '#d0d5dd',
          transform: is_configured ? 'translateY(-2px)' : 'none'
        } 
      }}
    >
      <CardContent sx={{ p: '20px !important', display: 'flex', alignItems: 'center' }}>
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            width: 44, 
            height: 44, 
            borderRadius: '12px',
            bgcolor: is_configured ? '#e8f5e9' : '#f2f4f7',
            color: is_configured ? '#2e7d32' : '#667085',
            mr: 2,
            flexShrink: 0
          }}
        >
          {is_configured ? <DescriptionOutlined /> : <AddCircleOutline />}
        </Box>

        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography 
            fontWeight="700" 
            variant="body1" 
            noWrap 
            sx={{ color: '#101828', mb: 0.5, fontSize: '1rem' }}
          >
            {name}
          </Typography>
          
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Chip 
              label={is_configured ? "Ready" : "Setup Required"} 
              size="small" 
              sx={{ 
                height: 22, 
                bgcolor: is_configured ? '#2e7d32' : '#f97316', 
                color: '#fff', 
                fontWeight: '700', 
                fontSize: '10px',
                px: 0.5
              }} 
            />
            {is_configured && (
              <Typography variant="caption" sx={{ color: '#667085', fontWeight: 500 }}>
                Updated: {last_updated}
              </Typography>
            )}
          </Stack>
        </Box>

        <Box sx={{ ml: 2 }}>
          <Button 
            variant={is_configured ? "outlined" : "contained"} 
            size="medium"
            onClick={(e) => {
              e.stopPropagation();
              onConfigure(type);
            }}
            endIcon={is_configured ? null : <ChevronRight />}
            sx={{ 
              borderRadius: '10px', 
              textTransform: 'none', 
              fontWeight: 700,
              fontSize: '0.875rem',
              minWidth: '100px',
              px: is_configured ? 2 : 3,
              boxShadow: 'none',
              '&:hover': { boxShadow: 'none' }
            }}
          >
            {is_configured ? "Edit" : "Setup"}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};